// components/RoleManagement/PermissionGroup.tsx
import { Card, Checkbox, Group, Stack, Text, Divider } from "@mantine/core";
import { PermissionType } from "constants/types/permission";
import { getPermissionModuleNameVi } from "utils/validation/string";

interface PermissionGroupProps {
  moduleName: string;
  permissions?: PermissionType[]; // Có thể undefined
  selectedCodes?: string[]; // Có thể undefined
  onTogglePermission: (code: string) => void;
  onToggleModule: (moduleName: string, isChecked: boolean) => void;
}

export const PermissionGroup = ({
  moduleName,
  permissions = [], // Gán mặc định là mảng rỗng nếu undefined
  selectedCodes = [], // Gán mặc định là mảng rỗng nếu undefined
  onTogglePermission,
  onToggleModule,
}: PermissionGroupProps) => {
  const moduleCodes = permissions.map((p) => p.code);

  // Kiểm tra an toàn: Nếu module không có quyền nào (length === 0) thì isAllSelected = false
  const isAllSelected =
    moduleCodes.length > 0 &&
    moduleCodes.every((code) => selectedCodes.includes(code));

  // Indeterminate (dấu trừ) khi có ít nhất 1 quyền được chọn nhưng chưa chọn hết
  const isIndeterminate =
    moduleCodes.some((code) => selectedCodes.includes(code)) && !isAllSelected;

  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder>
      <Group mb="xs">
        <Checkbox
          checked={isAllSelected}
          indeterminate={isIndeterminate}
          onChange={(event) =>
            onToggleModule(moduleName, event.currentTarget.checked)
          }
          label={
            <Text fw={600} tt="uppercase">
              {getPermissionModuleNameVi(moduleName)}
            </Text>
          }
          disabled={moduleCodes.length === 0} // Disable check all nếu không có data
        />
      </Group>
      <Divider mb="sm" />
      <Stack gap="xs">
        {permissions.length === 0 ? (
          <Text size="sm" c="dimmed" fs="italic">
            Không có dữ liệu quyền
          </Text>
        ) : (
          permissions.map((perm) => (
            <Checkbox
              key={perm.id}
              // Vì selectedCodes luôn là mảng (ít nhất là mảng rỗng), includes sẽ không bao giờ lỗi
              checked={selectedCodes.includes(perm.code)}
              onChange={() => onTogglePermission(perm.code)}
              label={perm.description}
            />
          ))
        )}
      </Stack>
    </Card>
  );
};
